import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Store, Action, State } from '@ngrx/store';

import { Effect, Actions, toPayload } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { AppState } from '../reducers';
import { AdditionalChargeActions } from '../actions';
import { MessageActions } from '../actions/message.actions';

import { ErrorHandlerService } from '../services/index';

import { AdditionalChargeApi, HttpClient } from '../services/webservice';
import { AdditionalCharge } from '../models';
import { AdditionalChargesToSave } from '../actions';

import { UnsafeAction } from '../actions/UnsafeAction';


@Injectable()
export class AdditionalChargeEffect {
	constructor(
		private updates$: Actions,
		private additionalChargeApi: AdditionalChargeApi,
		private additionalChargeActions: AdditionalChargeActions,
		private store: Store<AppState>,
		private errorHandler: ErrorHandlerService,
		private messageActions: MessageActions
	) { }

	@Effect() loadAdditionalCharges$ = this.updates$
		.ofType(AdditionalChargeActions.LOAD_ADDITIONALCHARGE_COLLECTION)
		.map(toPayload)
		.switchMap(url => this.additionalChargeApi.getAdditionalCharges(url))
		.map(additionalCharges => this.additionalChargeActions.loadCollectionSuccess(additionalCharges))

	@Effect() saveAdditionalCharges$ = this.updates$
		.ofType(AdditionalChargeActions.SAVE_ADDITIONALCHARGES)
		.flatMap((action: UnsafeAction) =>
			this.saveAdditionalCharges(action.payload)
		)
		.map(additionalCharges => this.additionalChargeActions.loadCollectionSuccess(additionalCharges))
		.catch((error) => Observable.of(this.additionalChargeActions.error(error)))
		.do(() => this.store.dispatch(this.messageActions.displayMessage("Zusätzliche Leistungen erfolgreich gespeichert.", "success")));

	@Effect() deleteAdditionalCharge$ = this.updates$
		.ofType(AdditionalChargeActions.DELETE_ADDITIONALCHARGE)
		.withLatestFrom(this.store)
		.flatMap(([action, state]: [UnsafeAction, AppState]) => this.additionalChargeApi.deleteAdditionalChargeByRef(action.payload)
			.mapTo(this.additionalChargeActions.loadCollection(state.eventServerState.additionalCharges.collectionUrl))
			.catch((error) => Observable.of(this.additionalChargeActions.error(error)))
		).do(() => this.store.dispatch(this.messageActions.displayMessage("Zusätzliche Leistung erfolgreich gelöscht.", "success")));

	@Effect() displayErrorMessage = this.updates$
		.ofType(AdditionalChargeActions.ADDITIONALCHARGE_ERROR)
		.flatMap((action: UnsafeAction) => this.handleError(action.payload, "Leider ist ein Fehler aufgetreten. Die Aktion war nicht erfolgreich."))

	private saveAdditionalCharges(additionalChargesToSave: AdditionalChargesToSave) {
		return Observable.from(additionalChargesToSave.additionalCharges)
			.concatMap(additionalCharge => this.createOrUpdateAdditionalCharge(additionalCharge))
			.toArray()
			.let(this.linkAdditionalCharges(additionalChargesToSave.additionalChargeCollectionUrl))
	}

	private createOrUpdateAdditionalCharge(additionalCharge: AdditionalCharge) {
		if (additionalCharge._links) return this.additionalChargeApi.updateAdditionalCharge(additionalCharge)
		else return this.additionalChargeApi.createAdditionalCharge(additionalCharge);
	}

	private linkAdditionalCharges(collectionUrl) {
		return (ob: Observable<AdditionalCharge[]>) =>
			ob.flatMap(additionalCharges =>
				this.additionalChargeApi.linkAdditionalCharge(
					collectionUrl, additionalCharges.map(charge => charge._links.self.href)
				).mapTo(additionalCharges)
			)
	}

	private handleError(error: Response, defaultMessage: string): Observable<Action> {
		let errorMessage = this.errorHandler.getErrorMessage(error,	defaultMessage)
		return Observable.of(this.messageActions.displayMessage(errorMessage, "error"))
	}
}



// WEBPACK FOOTER //
// ./src/app/effects/additional-charge.effect.ts